<template>
  <div>
    <v-card>
       <v-card-title><v-btn color="success" small @click="updateRegisteredTerminals"><v-icon>mdi-refresh</v-icon>Refresh</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
              small
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hint="Search on terminal id etc"
            ></v-text-field>
      </v-card-title>  
      <v-card-text>
        <v-data-table :headers="headers" :items="registeredTerminals" dense :sort-by="'terminalId'"  
        :loading ="dataLoading"
        :search="search"
        loading-text="Loading...">
          <template v-slot:item="{ item }">
            <tr @click="openTerminalMethod(item)" style="cursor:pointer">
              <td style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:200px;" :title="item.terminalId">{{ item.terminalId }}</td>
              <td style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:200px;">{{ item.publicId }}</td>
              <td>{{ item.venueCode }}</td>
              <td>{{ item.terminalBranch }}</td>
              <td>{{ item.terminalLocation }}</td>
              <td>{{ item.accountId }}</td>
              <td>{{ item.enabled }}</td>
              <td>{{ item.online }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.loggedIn }}</td>
              <td>{{ item.loggedOut }}</td>
              <td>{{ item.offline }}</td>
              <!-- <td class="styleActions px-0" style="width: 90px;">
                <v-btn color="#ea0b7c" fab x-small style="margin-right: 10px; color: white;">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="#ea0b7c" style="color: white;" fab x-small @click="deregisterTerminal(item.terminalId)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </td> -->
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <TerminalMethod :dialog="dialog" :terminal="terminal" @close="dialog = false"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TerminalMethod from './TerminalMethod.vue'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
  data () {
    return {
      dialog: false,
      terminal: {},
      dataLoading:false,
      search: "",
      headers: [
        {
          text: 'Terminal ID',
          value: 'terminalId'
        },
        {
          text: 'Public ID',
          value: 'publicId'
        },
        {
          text: 'Venue',
          value: 'venueCode'
        },
        {
          text: 'Branch',
          value: 'terminalBranch'
        },
        {
          text: 'Location',
          value: 'terminalLocation'
        },
        {
          text: 'Account',
          value: 'accountId'
        },
        {
          text: 'Enabled',
          value: 'enabled'
        },
        {
          text: 'Online',
          value: 'online'
        },
        {
          text: 'User',
          value: 'username'
        },
        {
          text: 'Last Login',
          value: 'loggedIn'
        },
        {
          text: 'Last Logout',
          value: 'loggedOut'
        },
        {
          text: 'Went Offline',
          value: 'offline'
        }
      ]
    }
  },
  async created () {
    await this.fetchRegisteredTerminals()
  },
  computed: {
    ...mapGetters('terminalStore',['getRegisteredTerminals']),
    ...mapGetters(['getUserPermissions','getUserLoggedIn']),
    registeredTerminals () {
      if( this.getUserLoggedIn?.roles.includes('*') 
      || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS,this.ROLEACTIONCODE.FULL)
      || this.userHasResourceAccess(this.RESOURCENAMES.TERMINALS_REGISTERED,this.ROLEACTIONCODE.FULL) 
      || this.userHasResourceAccess(this.RESOURCENAMES.MANAGEMENT) ) {
        return this.getRegisteredTerminals
      } else{
        return this.getRegisteredTerminals.filter(v=>this.userHasAccessToVenue(v.venueCode))
      }
      
    }
  },
  components: {
    TerminalMethod
  },
  methods: {
    ...mapActions('terminalStore',['fetchRegisteredTerminals', 'deregisterTerminal']),
    openTerminalMethod (v) {
      this.terminal = v
      this.dialog = true
    },
    async updateRegisteredTerminals () {
      this.dataLoading=true
      await this.fetchRegisteredTerminals()
      this.dataLoading=false
    },
    userHasAccessToVenue(venueCode){
      return this.getUserPermissions.find(p=>p.uri.split('-').includes(venueCode) && (p.actions.includes(this.ROLEACTIONCODE.READ) || p.actions.includes(this.ROLEACTIONCODE.FULL)))
    }
  }
}
</script>

<style>
.styleActions {
  width: 130px;
}
</style>
